// WDCE-199 step 9e: what the checkout screen does with OrdersController#update's answer. No React, fetch or DOM here,
// so it can be tested with bin/js-test; withOrder.jsx fetches and shows the outcome.
//
// decideOrderResponse takes what fetch returned: { networkError: true }, or { status, json, body } where json says
// whether the body was JSON and body is the parsed JSON. It returns one of:
// - { kind: 'ok', order }: a 2xx with the order. Checkout validation errors come back this way, in order.errors
//   (see checkoutErrorSteps).
// - { kind: 'refused', message, order, reload, leave }: a 409 or 422 with the server's own message, and the order if
//   it came back (else null). reload after order_paid, so staff see the paid page. leave for a deleted order (404), as
//   before.
// - { kind: 'unexpected', message }: a network error, a body that isn't JSON, a 5xx, or a shape it doesn't know.

// Never says whether a payment happened: money may have been taken.
export const UNEXPECTED_MESSAGE = 'Something went wrong. Reload the page and check the order before trying again.'
export const PICK_UP_OR_DELIVERY_MESSAGE =
  'Please choose pick up or delivery option and if choosing delivery please confirm your delivery address.'
export const INTERNATIONAL_DELIVERY_MESSAGE =
  'If you require international delivery please e-mail the winery for assistance with your order.'

const UNEXPECTED = { kind: 'unexpected', message: UNEXPECTED_MESSAGE }

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

// Each message once, in the order the keys came: a taken invoice email (WDCE-328) comes under two keys.
const serverMessage = (errors) =>
  Object.keys(errors).map((key) => errors[key]).filter((value) => typeof value === 'string' && value !== '')
    .filter((value, index, values) => values.indexOf(value) === index).join('\n')

export function decideOrderResponse(fetched) {
  if (!isObject(fetched) || fetched.networkError || !fetched.json || fetched.status >= 500) return UNEXPECTED

  const { status, body } = fetched
  if (!isObject(body)) return UNEXPECTED

  const order = isObject(body.order) && isObject(body.order.errors) ? body.order : null
  const errors = order ? order.errors : (isObject(body.errors) ? body.errors : null)

  if (status >= 200 && status < 300) return order ? { kind: 'ok', order } : UNEXPECTED

  if (status === 404 && errors && typeof errors.deleted_order_alert === 'string') {
    return { kind: 'refused', message: errors.deleted_order_alert, order: null, reload: false, leave: true }
  }

  if ((status === 409 || status === 422) && errors) {
    const message = serverMessage(errors)
    if (message !== '') {
      return { kind: 'refused', message, order, reload: errors.order_paid !== undefined, leave: false }
    }
  }

  return UNEXPECTED
}

// OrderForm's alerts after a checkout that came back with validation errors, in the same order as before: each known
// one, then the pick up or delivery text. { reload: true } is where it reloads the page.
export function checkoutErrorSteps(errors) {
  if (!isObject(errors) || Object.keys(errors).length === 0) return []

  const steps = []
  if (errors.foreign_country == 1) steps.push({ alert: INTERNATIONAL_DELIVERY_MESSAGE })
  if (errors.zero_quantity_selected != null) steps.push({ alert: errors.zero_quantity_selected }, { reload: true })
  steps.push({ alert: PICK_UP_OR_DELIVERY_MESSAGE })
  return steps
}
